var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEmail(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_27",
    "data-name": "Group 27",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 44.2 31.94",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_17",
    "data-name": "Rectangle 17",
    width: 44.2,
    height: 31.941,
    fill: "#e2bd69"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_26",
    "data-name": "Group 26",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2454",
    "data-name": "Path 2454",
    d: "M5.091,0Q25.452,0,45.813,0l.065.369c-.16.2-.3.407-.482.585q-9.123,9.121-18.253,18.235c-1.257,1.254-2.077,1.244-3.325,0Q14.8,10.173,5.783,1.162C5.526.9,5.279.635,5.028.371L5.091,0",
    transform: "translate(-3.25 0)",
    fill: "#e2bd69"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2455",
    "data-name": "Path 2455",
    d: "M5.2,63.1,19.86,48.47c.919.954,1.939,2.05,3,3.105,1.889,1.879,3.6,1.866,5.5-.017,1.047-1.04,2.081-2.093,3.084-3.1L46,63.013a8.874,8.874,0,0,1-1.431.238q-19.128.019-38.254,0A8.11,8.11,0,0,1,5.2,63.1",
    transform: "translate(-3.358 -31.319)",
    fill: "#e2bd69"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2456",
    "data-name": "Path 2456",
    d: "M.292,33.169a8.48,8.48,0,0,1-.279-1.555q-.028-13,0-26.007A8.3,8.3,0,0,1,.277,4.119L14.83,18.692.292,33.169",
    transform: "translate(0 -2.662)",
    fill: "#e2bd69"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2457",
    "data-name": "Path 2457",
    d: "M97.8,33.281,83.292,18.807l14.5-14.429A11.446,11.446,0,0,1,98.024,6q.022,12.8,0,25.6a13.444,13.444,0,0,1-.222,1.677",
    transform: "translate(-53.835 -2.83)",
    fill: "#e2bd69"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmail);
export default __webpack_public_path__ + "static/media/email.735670cedcfcb3a0b0c241703e856260.svg";
export { ForwardRef as ReactComponent };